let startTime: number | null = null;
let intervalId: ReturnType<typeof setInterval> | null = null;
let currentTime: number = 0;
let accumulatedTime: number = 0;

export const timeCounter = {
  start(): void {
    if (intervalId !== null) return;

    startTime = performance.now();

    intervalId = setInterval(() => {
      if (startTime !== null) {
        currentTime = Math.floor(accumulatedTime + (performance.now() - startTime));
      }
    }, 1); 
  },

  stop(): void {
    if (intervalId !== null) {
      clearInterval(intervalId);
      intervalId = null;
    }
    if (startTime !== null) {
      accumulatedTime += performance.now() - startTime;
      startTime = null;
    }
  },

  reset(): void {
    this.stop();
    currentTime = 0;
    startTime = null;
    accumulatedTime = 0;
  },

  getTime(): number {
    return currentTime;
  },

  formatTime(ms: number): number {
    const totalSeconds = (ms / 1000);
    return totalSeconds;
  }
};
